var render = function render(){var _vm=this,_c=_vm._self._c;return _c('maintenance-page',{attrs:{"page-title":"CostCentre","page-icon":"mdi-chart-pie","collection-name":"costcentre","done-redirect-url":"/auth/admin/costcentre?isHistory=true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }